var map = {
	"./android-app-download.png": 16,
	"./android-app-qrcode.png": 17,
	"./app.png": 18,
	"./avatar-upload.png": 19,
	"./avatar-upload.svg": 20,
	"./avatar.png": 21,
	"./bola-de-futebol.png": 22,
	"./brasileirao.png": 23,
	"./bronze-medal.svg": 24,
	"./calendar.png": 25,
	"./campo-de-futebol.png": 26,
	"./campo-de-futebol2.png": 27,
	"./champion.gif": 28,
	"./copaamerica.jpg": 29,
	"./dessi.jpeg": 30,
	"./dryer.gif": 31,
	"./dryer.png": 32,
	"./dryer.svg": 33,
	"./eliminated.svg": 34,
	"./football.png": 35,
	"./free.svg": 36,
	"./gabigol.jpg": 37,
	"./games.png": 38,
	"./gold-medal.svg": 39,
	"./gold-trophy.svg": 40,
	"./hello.png": 41,
	"./how_it_works_1.png": 42,
	"./how_it_works_2.png": 43,
	"./how_it_works_3.png": 44,
	"./how_it_works_4.png": 45,
	"./howtoplay1.png": 46,
	"./howtoplay2.png": 47,
	"./howtoplay3.png": 48,
	"./icon-login.svg": 49,
	"./joao-marcatto.jpg": 50,
	"./knock_out.png": 51,
	"./locked.svg": 52,
	"./logo.svg": 53,
	"./pago.svg": 54,
	"./paid_game.png": 55,
	"./pix.png": 56,
	"./podio.png": 57,
	"./qr_code_pix.jpeg": 58,
	"./railsway.png": 59,
	"./rank.png": 60,
	"./round-robin.svg": 61,
	"./round_robin.png": 62,
	"./serie_a.png": 63,
	"./serie_b.png": 64,
	"./silver-medal.svg": 65,
	"./site/16x16.png": 66,
	"./site/32x32.png": 67,
	"./site/64x64.png": 68,
	"./site/arrow-down.svg": 69,
	"./site/background.png": 70,
	"./site/check.svg": 71,
	"./site/close.svg": 72,
	"./site/e-futebol.png": 73,
	"./site/ellipse-left.svg": 74,
	"./site/ellipse-right.svg": 75,
	"./site/hamburguer.png": 76,
	"./site/hamburguer.svg": 77,
	"./site/hits.svg": 78,
	"./site/insta.png": 79,
	"./site/insta.svg": 80,
	"./site/laliga.svg": 81,
	"./site/mail.svg": 82,
	"./site/mailer.svg": 83,
	"./site/marks-left.svg": 84,
	"./site/marks-right.svg": 85,
	"./site/oficial_background.png": 86,
	"./site/premier.png": 87,
	"./site/rectangle.svg": 88,
	"./site/serie-a.png": 89,
	"./site/serie-b.png": 90,
	"./site/serie-c.png": 91,
	"./site/step-five.svg": 92,
	"./site/step-four.svg": 93,
	"./site/step-one.svg": 94,
	"./site/step-three.svg": 95,
	"./site/step-two.svg": 96,
	"./site/tack.svg": 97,
	"./site/trophies.svg": 98,
	"./site/whats.svg": 99,
	"./site/wpp.png": 100,
	"./survivor.svg": 101,
	"./survivor_.svg": 102,
	"./trophy-notice.svg": 103,
	"./trophy.gif": 104,
	"./trophy.svg": 105,
	"./unlocked.svg": 106,
	"./user.svg": 107,
	"./user_green.svg": 108,
	"./whats.png": 109,
	"./whatsapp2.png": 110,
	"./win_matches.png": 111,
	"./winner.svg": 112,
	"./word_2022.png": 113,
	"./wpp.png": 114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;